import { animate, style, transition, trigger } from '@angular/animations'
import { AsyncPipe, NgStyle } from '@angular/common'
import { Component, inject } from '@angular/core'
import { RouterLink } from '@angular/router'
import { map } from 'rxjs/operators'

import { HeaderService } from '@app/services/header.service'
import { MemberService } from '@app/services/member.service'
import { RenderService } from '@app/services/render.service'
import { SiteNavService } from '@app/services/site-nav.service'

import { CreditsNavigationDirective } from '../../../modules/navigation/directives/credits-navigation.directive'
import { ButtonComponent } from '../../../modules/ui/components/button/button.component'

@Component({
  selector: 'sb-member-header-account',
  templateUrl: './header-account.component.html',
  styleUrls: ['./header-account.component.scss'],
  animations: [
    trigger('siteNavToggle', [
      transition(':enter', [
        style({ opacity: 0, transform: 'scale(0)' }),
        animate('0.25s ease-in-out', style({ opacity: 1, transform: 'scale(1)' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, position: 'absolute', transform: 'scale(1)' }),
        animate('0.25s ease-in-out', style({ opacity: 0, transform: 'scale(0)' })),
      ]),
    ]),
  ],
  imports: [ButtonComponent, CreditsNavigationDirective, RouterLink, NgStyle, AsyncPipe],
})
export class MemberHeaderAccountComponent {
  private readonly renderService = inject(RenderService)
  readonly memberService = inject(MemberService)
  readonly siteNavService = inject(SiteNavService)
  readonly headerService = inject(HeaderService)

  readonly profilePhotoStyle$ = this.memberService.account$.pipe(
    map(account => {
      const url =
        account.profile_photo_id && account.profile_photo_url
          ? account.profile_photo_url
          : account.header_default_profile_photo_url
      return this.renderService.backgroundStyle(url)
    }),
  )
}
